module.exports = __webpack_public_path__ + "img/MEGA_80X30.b644be62.png";